import { MaterialReactTable } from "material-react-table";
import { invoiceColumns } from "./constants/CustomerTableColumns";
import { Card, Button, CardHeader, CardBody, Row } from "reactstrap";
import { invoiceChangeFunctionForCustomer } from "./constants/HandleChangeFunctions";

export default function Invoice({invoiceData}) {
  const invoiceArray = []
  const invoiceDataForCustomer = invoiceChangeFunctionForCustomer(invoiceData, invoiceArray)
  const columns = invoiceColumns();
  return (
    <div className="border rounded-1 px-4 py-3 my-2 bg-white h-100">
    <CardBody>
      <Row className="table-responsive">
      {/* <div className="d-flex justify-content-end align-items-center mb-2">
        <Button color="secondary" className="px-4">
          Pay
        </Button>
      </div> */}
      {invoiceDataForCustomer.length > 0 ?
      <MaterialReactTable
        columns={columns}
        data={invoiceDataForCustomer}
        muiTableHeadCellProps={{
          sx: {
            fontFamily: "Inter,sans-serif",
          },
        }}
        muiTablePaperProps={{
          elevation: 0,
        }}
        muiTableBodyCellProps={{
          sx: {
            fontFamily: "Inter,sans-serif",
            border: "none",
          },
        }}
        enableBottomToolbar={false}
        enableDensityToggle={false}
        enableSorting={false}
        enableColumnActions={true}
        renderTopToolbar={false}
      /> : (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>
          No record to display
        </div>
      )}
      </Row>
      </CardBody>
    </div>
  );
}
